import { isDefined } from "../../helpers";
export default function (store, { id, type = "task", targetDate, }) {
    const { stateDueDate } = store.getState();
    if (stateDueDate?.open ||
        !isDefined(id) ||
        (!store.existsTask(id) && type === "task") ||
        (!store.existsProject(id) && type === "project")) {
        return;
    }
    let value = null;
    if (type === "task") {
        value = store.getTask(id)?.text;
    }
    else if (type === "project") {
        value = store.getProject(id)?.label;
    }
    store.setState({
        stateEditableItem: {
            id,
            type,
            initValue: value,
            currentValue: value,
            targetDate,
        },
    });
}
//# sourceMappingURL=open.js.map